<section id="sticky-header">
  <div class="wrapper">
    <div *ngIf="submitted && maintenanceSearchForm.errors?.invalid"
      class="alert alert-danger alert-dismissible fade show server-error" #errorMessageDiv>
      <strong>Error!</strong> {{maintenanceSearchForm.errors?.invalid}}
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    </div>
  </div>
</section>
<!-- Common Container starts -->
<section class="wrapper">
  <div class="tracker-view-section mt-25">
    <div class="responsive-grid">
      <form [formGroup]="maintenanceSearchForm" (keyup.enter)="$event.preventDefault();searchmodeldata()">
        <div class="grid-row clearfix">
          <div class="col-25">
            <div class="relative">
              <input type="text" class="form-control" formControlName="customer" placeholder="Customer Id*">
            </div>
            <div *ngIf="submitted && maintenanceSearchForm.controls.customer.errors" class="invalid-feedback">
              <div *ngIf="maintenanceSearchForm.controls.customer.errors.required">This is required</div>
            </div>
          </div>
          <div class="col-25">
            <div class="relative">
              <input type="text" class="form-control" formControlName="state" placeholder="State*">
            </div>
            <div *ngIf="submitted && maintenanceSearchForm.controls.state.errors" class="invalid-feedback">
              <div *ngIf="maintenanceSearchForm.controls.state.errors.required">This is required</div>
            </div>
          </div>
          <div class="col-25">
            <div class="relative">
              <input type="text" class="form-control" formControlName="store" placeholder="Store*">
            </div>
            <div *ngIf="submitted && maintenanceSearchForm.controls.store.errors" class="invalid-feedback">
              <div *ngIf="maintenanceSearchForm.controls.store.errors.required">This is required</div>
            </div>
          </div>
          <div class="col-25">
            <div class="relative">
              <input type="text" class="form-control" formControlName="lot" placeholder="Lot*"
                oninput="this.value = this.value.toUpperCase()">
            </div>
            <div *ngIf="submitted && maintenanceSearchForm.controls.lot.errors" class="invalid-feedback">
              <div *ngIf="maintenanceSearchForm.controls.lot.errors.required">This is required</div>
            </div>
          </div>

        </div>
      </form>
      <div class="mt-25 align-right pb-20 mb-20">
        <button class="btn btn-secondary ml-10" (click)="cancelPage()">Cancel</button>
        <button class="btn btn-primary ml-10" (click)="searchmodeldata()">Search</button>
      </div>

      <div *ngIf="dataLoaded">
        <app-table [data]="rickCustomerData" [columns]="columns" [options]="options" (editRow)="editData($event)"
          (searchInfo)="searchData($event)" (copyRow)="copyData($event)" (viewRow)="viewData($event)"
          (addData)="addData()" (searchClear)="searchClear()"></app-table>
      </div>

    </div>
  </div>

</section>
<!-- Common Container ends -->